<template>
    <BreadCrumb PageTitle="Ajout d'un Approvisionnement" />
    <AddApprovisionnement />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddApprovisionnement from "@/components/Approvisionnement/AddApprovisionnement.vue";

    export default defineComponent({
        name: "AddApprovisionnementPage",
        components: {
            BreadCrumb,
            AddApprovisionnement,
        },
    });
</script>